package com.example.socialmediaapp.network

import kotlinx.serialization.Serializable

@Serializable
data class CallTokenRequest(val roomName: String)

@Serializable
data class CallTokenResponse(
    val roomUrl: String = "",    // Full Jitsi URL e.g. https://meet.yourdomain.ca/chat_123
    val roomName: String = "",
    val token: String? = null    // Optional JWT for authenticated Jitsi instances
)

class CallRepository(private val api: ApiClient) {

    suspend fun getRoom(roomName: String): Result<CallTokenResponse> = runCatching {
        api.post<CallTokenResponse>("/api/calls/token", CallTokenRequest(roomName))
    }
}
